import { useContext } from 'react';
import { AuthContext } from 'src/contexts/auth/multi-auth-context';

export const useAuth = () => useContext(AuthContext);
